import { ICopyTreinamentoUseCase } from "../../../presentation/useCases/create/copy_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CopyTreinamentoUseCase
 */

export class CopyTreinamentoUseCase implements ICopyTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async copyTreinamento(
    idTreinamento: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
  ): Promise<void> {
    await this.repository.copyTreinamento(
      idTreinamento,
      nome,
      versao,
      cargaHoraria,
    );
  }
}
